import apiClient from './apiService';
import {parseFiltersToQueryString} from "../utils/parseFiltersToQueryString";

class PromoterService {
    constructor() {
        if (PromoterService.instance) {
            return PromoterService.instance;
        }
        PromoterService.instance = this;
    }

    async getAll(filters = {}) {
        try {
            const queryString = parseFiltersToQueryString(filters);
            const response = await apiClient.get(`/promoters?${queryString}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async getAllWithPagination(filters = {}, page = 1, limit = 10) {
        try {
            const queryString = parseFiltersToQueryString(filters);
            const params = new URLSearchParams(queryString);
            params.append("page", page);
            params.append("size", limit);
            const response = await apiClient.get(`/promoters?${params.toString()}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }


    async getProspect(electorKey) {
        try {
            const response = await apiClient.get(`/prospect-promoters/${electorKey}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching prospect:', error);
            throw error.response?.data || error;
        }
    }

    async create(data) {
        try {
            const response = await apiClient.post('/promoters', data);
            return response.data;
        } catch (error) {
            console.error('Error creating promoter:', error);
            throw error.response?.data || error;
        }
    }

    async delete(id, deletionReason = null) {
        try {
            const response = await apiClient.delete(`/promoters/${id}`, {
                data: { deletionReason }
            });
            return response.data;
        } catch (error) {
            console.error('Error deleting promoter:', error);
            throw error.response?.data || error;
        }
    }

    async updateEmail(id, email) {
        try {
            const response = await apiClient.put(`/promoters/${id}/email`, { email });
            return response.data;
        } catch (error) {
            console.error('Error updating email:', error);
            throw error.response?.data || error;
        }
    }

    static getInstance() {
        if (!PromoterService.instance) {
            PromoterService.instance = new PromoterService();
        }
        return PromoterService.instance;
    }
}

export default PromoterService.getInstance();
